export const getNextTagName = ({ blocks }) => {
  if (!blocks.length) return;

  const currentTagName = blocks[0]?.tagName?.toLowerCase() || blocks[0]?.nodeName.toLowerCase();

  if (currentTagName === "p") return "h6";
  else if (currentTagName === "h1") return "p";
  else return `h${+currentTagName.split("")[1] - 1}`;
};

// Định nghĩa styles cho các heading levels
const headingStyles = {
  h1: { fontSize: "34px", lineHeight: "1.25" },
  h2: { fontSize: "30px", lineHeight: "1.3" },
  h3: { fontSize: "26px", lineHeight: "1.35" },
  h4: { fontSize: "22px", lineHeight: "1.4" },
  h5: { fontSize: "20px", lineHeight: "1.45" },
  h6: { fontSize: "18px", lineHeight: "1.5" },
};

// Get style cho một heading tag
export const getHeadingStyle = (tagName) => {
  const tag = tagName.toLowerCase();
  return headingStyles[tag] || null;
};

// Set style cho một heading element
export const setHeadingStyle = (element) => {
  const tagName = element.tagName.toLowerCase();
  const style = getHeadingStyle(tagName);

  if (!style) return;

  element.style.fontSize = style.fontSize;
  element.style.lineHeight = style.lineHeight;
};

// Apply style cho nhiều heading elements
export const applyHeadingStyles = (elements) => {
  elements.forEach((element) => setHeadingStyle(element));
};
